module.exports = __webpack_public_path__ + "img/last_page.8fd35935.svg";